import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import styled from 'styled-components'

export const StyledUserAccessProfileSwitchContainer = styled(GridItem)`
    align-items: flex-end;
`
